import { render, staticRenderFns } from "./ThemeDropdown.vue?vue&type=template&id=2b130964&"
import script from "./ThemeDropdown.vue?vue&type=script&lang=js&"
export * from "./ThemeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports